import { render, staticRenderFns } from "./FooterIconLegend.vue?vue&type=template&id=7b3efbf0"
import script from "./FooterIconLegend.js?vue&type=script&lang=js&external"
export * from "./FooterIconLegend.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports